import React, { useState, useEffect } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { getElementName } from "../../helpers/helpers";
import { Checkbox, FormControlLabel, FormGroup, Tooltip } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import InfoIcon from "@mui/icons-material/Info";

export default function EditRoleInformation(props) {
  const { t } = useTranslation();

  const schema = yup.object().shape({
    product: yup.string().required(t("App.validationMessages.required")),
    role: yup
      .string()
      .required(t("App.validationMessages.required"))
      .matches(/^[a-zA-Z\u00C0-\u00FF\s]+$/, "Este campo solo admite letras"),
    description: yup
      .string()
      .required(t("App.validationMessages.required"))
      .matches(
        /^[a-zA-Z\\\,\u00C0-\u00FF\s]+$/,
        "Este campo solo admite letras"
      ),
    status: yup.string().required(t("App.validationMessages.required")),
  });

  const {
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
    props.onClose(open);
  };

  const nextStep = () => {
    props.nextStep(1);
  };

  useEffect(() => {
    const roleInfo = props.currentRole;

    setValue("product", roleInfo.idMenuOption ? roleInfo.idMenuOption : "");
    setValue("role", roleInfo.nameRole ? roleInfo.nameRole : "");
    setValue(
      "description",
      roleInfo.descriptionRole ? roleInfo.descriptionRole : ""
    );
    setValue("status", roleInfo.state !== "" ? roleInfo.state : "");

    setCheckBoxValue(props.currentRole.clientType);
  }, []);

  const [productName, setProductName] = useState("");
  const [checkBoxValue, setCheckBoxValue] = useState(false);

  const handleInformation = async (data, e) => {
    try {
      const obj = {
        idProduct: data.product,
        product: productName || props.roleInfo.product,
        role: data.role,
        description: data.description,
        status: Number(data.status),
        clientType: checkBoxValue ? "SI" : "NO",
      };

      props.pullDataInfo(obj);
      nextStep();
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    }
  };

  return (
    <Grid>
      <p className="heading__text-grey">{t("App.createUser.information")}</p>

      <form onSubmit={handleSubmit(handleInformation)} name="form" id="form">
        <Grid className="modalEditRoles__form-box">
          <FormControl>
            <InputLabel className="modalCreateOptions__form__inputLabel ">
              {t("App.editRole.product")}
            </InputLabel>

            <Controller
              defaultValue=""
              control={control}
              name="product"
              render={({
                field: { onChange, onBlur, value, name, ref },
                formState,
              }) => (
                <Select
                  value={value}
                  labelId="labelProduct"
                  label={t("App.editRole.product")}
                  className={
                    errors.product
                      ? "modalEditRoles__form-input--error"
                      : "modalEditRoles__form-input"
                  }
                  onChange={onChange}
                  onClick={(e) => setProductName(getElementName(e.target))}
                >
                  <MenuItem disabled value="">
                    <em>{t("App.createRole.product")}</em>
                  </MenuItem>
                  {props.activeProducts.map((product) => {
                    return (
                      <MenuItem
                        sx={{
                          display: product.selected ? "none" : "",
                        }}
                        key={product.value}
                        value={product.value}
                        name={product.label}
                      >
                        {product.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              )}
            />

            <FormHelperText
              sx={{
                margin: "-10px 0 0 0",
                color: "#e52900",
              }}
            >
              {errors.product ? errors.product.message : ""}
            </FormHelperText>
          </FormControl>

          <Controller
            control={control}
            name="role"
            render={({
              field: { onChange, onBlur, value, name, ref, defaultValue },
              formState,
            }) => (
              <TextField
                value={value}
                className={
                  errors.role
                    ? "modalEditRoles__form-input--error"
                    : "modalEditRoles__form-input"
                }
                helperText={errors.role ? errors.role.message : ""}
                InputLabelProps={{
                  style: {
                    margin: "-5px 0 0 -10px",
                    padding: "0 0 0 5px",
                    color: "#8c8d9d",
                    fontSize: 13,
                  },
                }}
                FormHelperTextProps={{
                  style: {
                    margin: "-5px 0 0 0",
                    color: "#e52900",
                  },
                }}
                id={name}
                name={name}
                label={t("App.editRole.role")}
                onChange={onChange}
                onBlur={onBlur}
                inputRef={ref}
              />
            )}
          />

          <FormControl>
            <InputLabel className="modalCreateOptions__form__inputLabel ">
              {t("App.editRole.status")}
            </InputLabel>
            <Controller
              defaultValue=""
              control={control}
              name="status"
              render={({
                field: { onChange, onBlur, value, name, ref },
                formState,
              }) => (
                <Select
                  value={value}
                  labelId="labelStatus"
                  label={t("App.editRole.status")}
                  className={
                    errors.status
                      ? "modalEditRoles__form-input--error"
                      : "modalEditRoles__form-input"
                  }
                  onChange={onChange}
                >
                  <MenuItem disabled value="">
                    <em>{t("App.editRole.status")}</em>
                  </MenuItem>
                  <MenuItem value={1}>{t("App.editRole.active")}</MenuItem>
                  <MenuItem value={0}>{t("App.editRole.inactive")}</MenuItem>
                </Select>
              )}
            />

            <FormHelperText
              sx={{
                margin: "-10px 0 0 0",
                color: "#e52900",
              }}
            >
              {errors.status ? errors.status.message : ""}
            </FormHelperText>
          </FormControl>

          <Controller
            control={control}
            name="description"
            render={({
              field: { onChange, onBlur, value, name, ref, defaultValue },
              formState,
            }) => (
              <TextField
                className={
                  errors.description
                    ? "modalEditRoles__form-description--error"
                    : "modalEditRoles__form-description"
                }
                helperText={
                  errors.description ? errors.description.message : ""
                }
                InputLabelProps={{
                  style: {
                    margin: "-5px 0 0 -10px",
                    padding: "0 0 0 5px",
                    color: "#8c8d9d",
                    fontSize: 13,
                  },
                }}
                FormHelperTextProps={{
                  style: {
                    margin: "-5px 0 0 0px",
                    color: "#e52900",
                  },
                }}
                id={name}
                name={name}
                label={t("App.editRole.description")}
                onChange={onChange}
                onBlur={onBlur} // notify when input is touched/blur
                value={value}
                inputRef={ref} // send input ref, so we can focus on input when error appear
              />
            )}
          />

          <Grid item container alignItems="center">
            <Grid item>
              <FormGroup
                style={{
                  padding: "0 !important",
                }}
              >
                <FormControlLabel
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      color: "#543ab4 !important",
                      fontFamily: "Roboto !important",
                      fontWeight: "100 !important",
                      cursor: "default",
                    },
                  }}
                  control={
                    <Checkbox
                      defaultChecked={
                        props.currentRole.clientType === "SI" ? true : false
                      }
                      disabled={props.currentRole.containsUsers ? true : false}
                      sx={{
                        color: props.currentRole.containsUsers
                          ? "#c0c1d8 !important"
                          : "553ab6 !important",
                      }}
                      className="modalPreviewMenu__form-checkbox"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onChange={(e) => {
                        setCheckBoxValue(e.target.checked);
                      }}
                      checkedIcon={<CheckBoxOutlinedIcon />}
                      uncheckedIcon={<CheckBoxOutlineBlankIcon />}
                    />
                  }
                  label={t("App.listRoles.clientType")}
                />
              </FormGroup>
            </Grid>

            <Grid item>
              <Tooltip
                title={
                  props.currentRole.containsUsers ? (
                    <span>
                      <p>{t("App.editRole.tooltipTextOne")}</p>
                      <p>{t("App.editRole.tooltipTextTwo")}</p>
                      <p>{t("App.editRole.tooltipTextThree")}</p>
                      <p>{t("App.editRole.tooltipTextFour")}</p>
                    </span>
                  ) : (
                    <span>
                      <p>{t("App.createRole.tooltipTextOne")}</p>
                      <p>{t("App.createRole.tooltipTextTwo")}</p>
                      <p>{t("App.createRole.tooltipTextThree")}</p>
                      <p>{t("App.createRole.tooltipTextFour")}</p>
                    </span>
                  )
                }
              >
                <InfoIcon style={{ color: "#553AB6" }} />
              </Tooltip>
            </Grid>
          </Grid>
          <Grid
            className="modalCreateRoles__form__actions"
            spacing={2}
            item
            container
            justifyContent="center"
          >
            <Grid item>
              <Button className="btn__filled__gradient" onClick={handleClose}>
                {t("App.createRole.cancelButton")}
              </Button>
            </Grid>

            <Grid item>
              <Button
                autoFocus
                disabled={
                  watch("role") &&
                  watch("description") &&
                  watch("status") !== "" &&
                  watch("product")
                    ? false
                    : true
                }
                type="submit"
                className="modalCreateRoles__form__actions-buttonFilled"
              >
                {t("App.createRole.continueButton")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
}
